import React, { useState } from "react";
import { Button, TextInput, PasswordInput } from "@mantine/core";
import apiService from "../../services/api";
import { AdminLoginProps, ApiResponse } from "../../types";

const AdminLogin: React.FC<AdminLoginProps> = ({ onLoginSuccess, onBackToHome }) => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = (await apiService.adminLogin(username, password)) as ApiResponse;

      if (response.Code === 200) {
        // Store admin session
        localStorage.setItem("adminLoggedIn", "true");
        onLoginSuccess();
      } else {
        setError(response.Message || "Invalid credentials");
      }
    } catch (err) {
      console.error("Admin login error:", err);
      setError("Failed to connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="font-sans bg-background min-h-screen flex items-center justify-center p-5">
      <div className="bg-card rounded-2xl p-10 shadow-[0_20px_60px_rgba(230,126,34,0.15)] border border-border max-w-[500px] w-full">
        <h1 className="text-foreground mb-2 text-center text-3xl font-bold">Admin Login</h1>
        <p className="text-muted-foreground mb-8 text-center">
          Administrative access to the Pheefee platform
        </p>

        {error && (
          <div className="bg-destructive/10 text-destructive border border-destructive/25 p-3 rounded-lg mb-5 text-center">
            {error}
          </div>
        )}

        <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
          <TextInput
            label="Username"
            value={username}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
            placeholder="Enter admin username"
            required
            autoFocus
            radius="md"
            size="md"
          />

          <PasswordInput
            label="Password"
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
            placeholder="Enter admin password"
            required
            radius="md"
            size="md"
          />

          <Button type="submit" loading={loading} radius="md" size="lg" className="mt-2">
            Login
          </Button>

          <Button
            type="button"
            onClick={onBackToHome}
            variant="outline"
            color="dark"
            radius="md"
            size="lg"
            disabled={loading}
            className="mt-2"
          >
            Cancel
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
